import API from './API.js'

export default class Increments extends API {
  constructor() {
    super('increments')
  }
}
